// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"a61bde53caf96c7c5687","655":"cd65f2359b8c1d9b4026"}[chunkId] + ".js";
};